module.exports = "https://coursera_assets.s3.amazonaws.com/images/ee9b925d108f2f5943b7450d91abcda9.png";